import React, { useState } from "react";
import { FaSearch, FaShoppingCart, FaUser } from "react-icons/fa";
import { HiMenu } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

import logo1 from "../Images/logo2.jpg";
import logo from "../Images/logo2.jpg";

import { useCart } from "./CartContext";

function Navbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Cart
  const { cartCount } = useCart();

  // Navigation
  const navigate = useNavigate();

  const suggestions = [
    "African Dress",
    "Men dresses",
    "women dresses",
    "Women Accessories",
    "Party Wear",
    "Kids Clothing",
    "Gift Items",
  ];

  const filteredSuggestions = suggestions.filter((s) =>
    s.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Open Login Modal
  const handleProfileClick = () => {
    window.dispatchEvent(new Event("openLoginModal"));
  };

  // Open Cart
  const handleCartClick = () => {
    navigate("/cart");
  };

  return (
    <>
      {/* Mobile Heading */}
      <div
        className="d-md-none text-center py-2 mobile-brand1"
        data-aos="zoom-in"
      >
        <img
          src={logo}
          alt="Logo"
          className="mobile-logo"
          data-aos="zoom-in"
        />

        <span className="mobile-brand-text">
          Fashion Afrique
        </span>
      </div>

      <nav className="navbar shadow-sm px-3">
        <div className="container-fluid d-flex justify-content-between align-items-center">

          {/* Left - Desktop */}
          <div className="d-none d-md-flex align-items-center gap-2 desktop-brand">
            <img
              src={logo1}
              alt="Logo"
              className="logo-img"
              data-aos="zoom-in"
            />

            <h4 className="m-0 brand-desktop">
              Fashion Afrique
            </h4>
          </div>

          {/* Menu Button - Mobile */}
          <button
            className="btn d-md-none menu-btn"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
          >
            <HiMenu size={28} />
          </button>

          {/* Right Icons */}
          <div className="d-flex align-items-center gap-3 navbar-icons fs-5">

            {/* Search */}
            <div
              className={`search-wrapper ${
                searchOpen ? "active" : ""
              }`}
            >
              <FaSearch
                className="search-icon"
                onClick={() =>
                  setSearchOpen(!searchOpen)
                }
                data-aos="zoom-in"
              />

              <input
                type="text"
                placeholder="Search products..."
                value={searchQuery}
                onChange={(e) =>
                  setSearchQuery(e.target.value)
                }
                className="search-input"
              />

              {searchOpen && searchQuery && (
                <ul className="search-suggestions">
                  {filteredSuggestions.length > 0 ? (
                    filteredSuggestions.map((s, i) => (
                      <li key={i}>{s}</li>
                    ))
                  ) : (
                    <li>No results</li>
                  )}
                </ul>
              )}
            </div>

            {/* Cart */}
            <div
              className="icon-wrapper"
              data-aos="zoom-in"
              onClick={handleCartClick}
              style={{
                cursor: "pointer",
                position: "relative",
              }}
              title="Shopping Cart"
            >
              <FaShoppingCart />

              {/* Dynamic Cart Count */}
              {cartCount > 0 && (
                <span className="badge">
                  {cartCount}
                </span>
              )}
            </div>

            {/* Account / Profile */}
            <div
              className="icon-wrapper"
              data-aos="zoom-in"
              onClick={handleProfileClick}
              style={{ cursor: "pointer" }}
              title="Login / Profile"
            >
              <FaUser />
            </div>

          </div>
        </div>
      </nav>

      {/* Mobile Offcanvas */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileMenu"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">
            Menu
          </h5>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body">
          <ul className="list-unstyled">

            <li className="py-2 border-bottom">
              Brand New
            </li>

            <li className="py-2 border-bottom">
              Trending
            </li>

            <li className="py-2 border-bottom">
              Shop All
            </li>

            <li className="py-2 border-bottom">
              Accessories
            </li>

            <li className="py-2 border-bottom">
              Size Chart
            </li>

            <li className="py-2 border-bottom">
              Reviews
            </li>

            <li className="py-2 border-bottom">
              Help
            </li>

          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;

